module.exports = __webpack_public_path__ + "static/how-to-avoid-delivery-delays-featured-d8bf968d53b88ae9942c1d0be72cce3b.png";